import { render, staticRenderFns } from "./CardEstadistica.vue?vue&type=template&id=162661b2&"
import script from "./CardEstadistica.vue?vue&type=script&lang=js&"
export * from "./CardEstadistica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports